// Recovered compiled webpack factory 23863. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { i: () => n });
  let n = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
}
